export default function About() {
  return (
    <section id="about" className="py-24 bg-[#F8F9FA]">
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <div className="text-center mb-16">
          <div className="inline-flex items-center gap-2 bg-[#00D4AA]/10 text-[#00D4AA] px-4 py-2 rounded-full mb-6">
            <i className="ri-shield-check-line"></i>
            <span className="font-semibold text-sm uppercase tracking-wide">Who We Are</span>
          </div>
          <h2 className="text-4xl lg:text-5xl font-bold text-[#1A1F36] mb-6">
            SALINAS S.R.L.
          </h2>
        </div>

        <div className="grid lg:grid-cols-5 gap-12 items-center">
          <div className="lg:col-span-3 space-y-6">
            <p className="text-lg text-gray-700 leading-relaxed">
              At SALINAS S.R.L., we are dedicated to protecting your digital freedom and privacy. Based in Paraná, Argentina, we specialize in developing cutting-edge VPN solutions that ensure your online activities remain secure and private.
            </p>
            <p className="text-lg text-gray-700 leading-relaxed">
              Our mission is to provide enterprise-grade security accessible to everyone. We believe that privacy is a fundamental right, and our VPN service is built on the principles of transparency, reliability, and unwavering commitment to user protection.
            </p>
            <p className="text-lg text-gray-700 leading-relaxed">
              With advanced encryption technology and a global network infrastructure, we empower individuals and businesses to browse the internet freely, securely, and without limitations.
            </p>
          </div>

          <div className="lg:col-span-2">
            <div className="bg-gradient-to-br from-[#00D4AA] to-[#00BF99] rounded-[40px] p-10 shadow-lg">
              <div className="space-y-6 text-white">
                <div className="flex items-start gap-4">
                  <div className="w-12 h-12 bg-white/20 rounded-lg flex items-center justify-center flex-shrink-0">
                    <i className="ri-shield-star-line text-2xl"></i>
                  </div>
                  <div>
                    <h3 className="font-bold text-xl mb-2">Security First</h3>
                    <p className="text-white/90">Military-grade encryption protecting your data</p>
                  </div>
                </div>

                <div className="flex items-start gap-4">
                  <div className="w-12 h-12 bg-white/20 rounded-lg flex items-center justify-center flex-shrink-0">
                    <i className="ri-user-heart-line text-2xl"></i>
                  </div>
                  <div>
                    <h3 className="font-bold text-xl mb-2">Privacy Focused</h3>
                    <p className="text-white/90">No logs, no tracking, complete anonymity</p>
                  </div>
                </div>

                <div className="flex items-start gap-4">
                  <div className="w-12 h-12 bg-white/20 rounded-lg flex items-center justify-center flex-shrink-0">
                    <i className="ri-global-line text-2xl"></i>
                  </div>
                  <div>
                    <h3 className="font-bold text-xl mb-2">Global Reach</h3>
                    <p className="text-white/90">Servers worldwide for optimal performance</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
